import * as angular from 'angular';
import * as _ from 'lodash';
import {ConfigScope, EquipmentDataPoint} from "./config.base";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import {PlantLocation} from "../../services/locations/locations.service";
import template from './raspberryPiDataPoints.tpl.html';

let requires = [NewGuidServiceName, UIUtilityServiceName];

interface RaspberryPiDataPointsScope extends ConfigScope {
  types: EnumOption[];
  locations: PlantLocation[];
  addDataPoint(): void;
  removeDataPoint(dataPoint: EquipmentDataPoint): void;
}

export default angular.module('aps.controller.raspberryPiDataPoints', requires)
  .directive('apsRaspberryPiDataPoints', raspberryPiDataPoints)
  .name;

function raspberryPiDataPoints(
  newGuidService: NewGuidService,
  uiUtilityService: UIUtilityService
): angular.IDirective {
  return {
    restrict: 'E',
    template: template,
    link: (scope: RaspberryPiDataPointsScope) => {
      scope.types = uiUtilityService.getListOptionsFromEnum(apsEnums.DataPointType, 1);
      scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, ['jsonConfig.Channel', 'name']);
      scope.addDataPoint = () => {
        let dataPoint = {
          config: null,
          jsonConfig: {},
          configType: apsEnums.DataPointConfigType.RaspberryPiCounter,
          id: null,
          name: '',
          type: null,
          plantLocationId: scope.vm.location.location.id
        };
        newGuidService.getNewGuid('dataPoint').then(id => dataPoint.id = id);
        scope.vm.dataPoints.push(dataPoint);
      };

      let setDataPointLocations = () => {
        scope.locations = [scope.vm.location].concat(scope.vm.location.children);

        scope.vm.dataPoints.forEach(dp => {
          if (_.some(scope.locations, l => l.location.id === dp.plantLocationId)) {
            return;
          }
          dp.plantLocationId = scope.vm.location.location.id;
        });
      };

      scope.$watch('vm.location', setDataPointLocations);
      setDataPointLocations();

      scope.removeDataPoint = (dataPoint: EquipmentDataPoint) =>
        _.remove(scope.vm.dataPoints, dataPoint);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/raspberryPiDataPoints.directive.ts